import defaultValues from './defaultValues'

const target = JSON.parse(defaultValues);

export default target;